import React, { Component } from 'react';
import XLSX from 'xlsx';
import { Button } from "reactstrap";
class ExcelReader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      file: {},
      fileName: "",
      dataExcel: [],
      cols: [],
      msgFile: ""
    }
    this.handleFile = this.handleFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const files = e.target.files;
    if (files && files[0]) this.setState({ file: files[0], fileName: files[0].name || "Hãy chọn file" });
  }
  handleFile() {
    if (this.state.fileName == '') {
      this.setState({ msgFile: "Bạn chưa nhập file danh sách." });
    } else {
      this.setState({ msgFile: "" });
      /* Boilerplate to set up FileReader */
      const reader = new FileReader();
      const rABS = !!reader.readAsBinaryString;

      reader.onload = (e) => {
        /* Parse data */
        const bstr = e.target.result;
        const wb = XLSX.read(bstr, { type: rABS ? 'binary' : 'array', bookVBA: true });
        /* Get first worksheet */
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        /* Convert array of arrays */
        const dataExcel = XLSX.utils.sheet_to_json(ws, {
          header: 1,
          defval: '',
          blankrows: false
        });
        /* Update state */
        this.props.UploadExcel(dataExcel);
        // this.setState({ dataExcel: dataExcel, cols: make_cols(ws['!ref']) }, () => {
        //   console.log(JSON.stringify(this.state.dataExcel, null, 2));
        // });
      }
      if (rABS) {
        reader.readAsBinaryString(this.state.file);
      } else {
        reader.readAsArrayBuffer(this.state.file);
      }
    }
  }
  render() {
    const {
      btnText
    } = this.props

    return (
      <div className="row">
        <div className="col-sm-8 pr-0">
          <div className="custom-file">
            <input type="file" className="custom-file-input" id="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" onChange={this.handleChange} />
            <label className="custom-file-label" htmlFor="file">{this.state.fileName}</label>
            <p className="text-danger">{this.state.msgFile}</p>
          </div>
        </div>
        <div className="col-sm-4">
          <Button color="primary" onClick={this.handleFile}><i className="fa fa-upload mr-1"></i>{btnText ? btnText : 'Tải danh sách'}</Button>
        </div>
      </div>
    )
  }
}

export default ExcelReader;


// WEBPACK FOOTER //
// ./src/views/controls/_ExcelReader.js